import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// Temporarily disabled for debugging
// import { registerSW } from 'virtual:pwa-register';

// Register service worker
// const updateSW = registerSW({
//   onNeedRefresh() {
//     if (confirm('New content available. Reload?')) {
//       updateSW(true);
//     }
//   },
//   onOfflineReady() {
//     console.log('App is ready to work offline');
//   }
// });

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);